// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ViKXX","checkboxCol":"Table_checkboxCol__11I7L","emailCol":"Table_emailCol__37Mg2","actionCol":"Table_actionCol__IkiVN"};